<!-- 首页-AI-编辑器模块 -->
<template>
  <div class="aiEditorVideo">
    <homeModuleHead :apply="aiEditor"></homeModuleHead>
    <div class="aiEditorVideo-center">
      <div class="center-left">
        <video
          class="ai-editor-video" 
          ref="videoPlayer"
          muted="true"
          :autoplay="true"
          :src="currentVideo.list[currentVideoIndex].videoUrl"
          @ended="ended"
        ></video>
        <div class="center-left-bottomNav">
          <span class="el-icon-arrow-left" @click="onVideoLeft"></span>
          <div class="bottomNav-tips">
            <p>{{currentVideo.list[currentVideoIndex].videoTips}}</p>
            <ul>
              <li :class="[index===currentVideoIndex?'current-dot':'']" v-for="(item, index) in currentVideo.list" :key="index"></li>
            </ul>
          </div>
          <span class="el-icon-arrow-right" @click="onVideoRight"></span>
        </div>
      </div>
      <div class="center-right">
        <!-- 上下箭头 -->
        <!-- <div class="arrow">
          <span class="arrow-top"></span>
          <span class="arrow-bottom"></span>
        </div> -->
        <ul>
          <li v-for="(item, index) in videoList" :key="index"  @click="onSelectVideo(item, index)">
            <span class="mode-title">{{item.patternTitle}}</span>
            <img :class="[currentIndex == index ? 'selector-img':'']" :src="item.imgUrl" alt="">
          </li>
        </ul>
      </div>

      <div class="special-effects">
        <ul class="ul-left">
          <li :class="[leftIndex >= index ? 'li-hover-left' : '']" v-for="index in 20" :key="index"></li>
        </ul>
        <span>{{currentVideo.patternTitle}}</span>
        <ul class="ul-right">
          <li :class="[rightIndex >= index ? 'li-hover-right' : '']" v-for="index in 20" :key="index"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import homeModuleHead from './HomeModuleHead.vue' // 头部
import SOURCE from '../../../public/sources/sources.js'
export default {
  name: 'aiEditorVideo',
  components: { homeModuleHead },
  props: {
    title: {//模块标题
        type: String,
        default: ""
    },
    projectList: {
      Type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      aiEditor: {
        titleEnglish: ['THE', 'AI EDITOR'],
        title: 'AI编辑器',
        intro: "积木代码双模式编程，让AI创研更灵活",
        more: "马上创作",
        redirect: '/ai/editor',
        openUrl: "aiEditorVideo"
      },
      // patternTitle: '积木模式',
      currentVideoIndex: 0, // 当前视频下标
      currentIndex: 0, // 当前积木/代码视频下标
      currentVideo: {}, // 选中当前视频
      videoList: [
        {
          patternTitle: '积木模式',
          imgUrl: require('../../../public/images/home/ai-block-editor-img.png'),
          list: [
            {
              videoUrl:SOURCE.pro['ai-block-editor-1'],
              // videoUrl: require('../../../public/sources/ai-block-editor-1.mp4'),
              videoId: '1',
              videoTips: '第一步，拖出功能积木，拼接好积木，完成项目搭建。'
            },
            {
              videoUrl:SOURCE.pro['ai-block-editor-2'],
              videoId: '2',
              videoTips: '第二步，点击“查看代码”，可查看项目程序Python代码。'
            },
            {
              videoUrl:SOURCE.pro['ai-block-editor-3'],
              videoId: '3',
              videoTips: '第三步，运行项目程序，显示结果。'
            },
          ]
        },
        {
          patternTitle: '代码模式',
          imgUrl: require('../../../public/images/home/ai-code-editor-img.png'),
          list: [
            {
              videoUrl:SOURCE.pro['ai-code-editor-1'],
              videoId: '1',
              videoTips: '第一步，输入代码，编写程序。'
            },
            {
              videoUrl:SOURCE.pro['ai-code-editor-2'],
              videoId: '2',
              videoTips: '第二步，查看算法模型API文档，调用算法模型。'
            },
            {
              videoUrl:SOURCE.pro['ai-code-editor-3'],
              videoId: '3',
              videoTips: '第三步，完善代码程序。'
            },
            {
              videoUrl:SOURCE.pro['ai-code-editor-4'],
              videoId: '4',
              videoTips: '第四步，运行项目程序，显示结果。'
            },
          ]
        },
      ],
      autoplay: true, //是否自动切换
      isPlay:false, //播放状态
      isIn:false, //鼠标是否位于播放器内
      cutTime:5000, //轮播时间，单位毫秒
      nowIndex: 1, // 行业应用走马灯当前下标
      playState: false, // 播放状态
      timer: null,
      leftIndex: 1,
      rightIndex: 1,
    }
  },
  watch:{
    // projectList(val) {
    //   if (val) {
    //     this.videoList = JSON.parse(JSON.stringify(val))
    //     this.currentVideo = this.videoList[0]
    //     if (this.videoList.length > 1) {
    //       this.videoList.push(this.videoList[0])
    //     }
    //   }
    // }
  },
  computed: {
    classOption () {
       return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created() {
    this.currentVideo = this.videoList[0]
  },
  mounted() {
    // this.videoRotation()
    this.animationEffect() // AI编辑器动画效果
  },
  methods: {
    // AI编辑器动画效果
    animationEffect() {
      setInterval(() => {
        this.leftIndex++
        this.rightIndex++
        if (this.leftIndex >= 21 || this.rightIndex >= 21) {
          this.leftIndex = 0
          this.rightIndex = 0
        }
      }, 80);
    },
    // 选中视频
    onSelectVideo(val, index) {
      this.currentVideo = val
      this.currentIndex = index
      this.currentVideoIndex = 0
    },
    onVideoLeft() {
      let currentVideoLength = this.currentVideo.list.length
      if (this.currentVideoIndex === 0) {
        this.currentVideoIndex = currentVideoLength - 1
      } else {
        this.currentVideoIndex--
      }
    },
    onVideoRight() {
      let currentVideoLength = this.currentVideo.list.length
      if (this.currentVideoIndex === currentVideoLength - 1) {
        this.currentVideoIndex = 0
      } else {
        this.currentVideoIndex++
      }
    },

    // 视频轮播
    videoRotation() {
      let this_ = this
      // 实现：
      // 1 获取元素
      var box = document.getElementById('ai-video-box'); // 大盒子
      var screenBox = box.children[0]; // 可视区域
      var imgWidth = screenBox.offsetWidth; // 获取可视区域宽度作为图片宽度使用
      var ul = screenBox.children[0]; // 运动的ul
      var ulLis = ul.children; // ul中的所有子元素li
      var ol = screenBox.children[1]; // 小方块的父元素
      var olLis = ol.children; // ol中的所有子元素li
      var arrBox = box.children[1]; // 左右箭头父盒子
      var arrLeft = arrBox.children[0]; // 左箭头
      var arrRight = arrBox.children[1]; // 右箭头
  
  
      // 2 设置一个变量用于记录滚出去的张数
      var count = 1;
      // 设定在第二张为中间位置
      ul.style.left = imgWidth;
      var target = -count * imgWidth;
      move(ul, target);
  
      // 3 设置右按钮点击事件
      arrRight.onclick = function () {
        // --- 如果当前是假的第一张显示时，应当先将ul的left抽回到0，再滚动
        if (count === ulLis.length - 2) {
          ul.style.left = 0;
          // 注意：ul的位置如果发生改变，count值要随之改变
          count = 0;
        }
  
  
        // - 设置计数+1
        count++;
        // - 根据count设置ul的运动位置
        var target = -count * imgWidth;
        move(ul, target);
  
        // - 设置按钮变色
        // for (var i = 0; i < olLis.length; i++) {
        //   olLis[i].classList.remove('current');
        // }
        // // 设置了假的第一张后，假的第一张显示时应当为按钮1高亮
        // if (count === ulLis.length - 1) {
        //   olLis[0].classList.add('current');
        // } else {
        //   olLis[count].classList.add('current');
        // }

        if (this_.playState) {
          let myVideo = this_.$refs['videoPlayer' + this_.nowIndex];
          myVideo[0].pause();
        }

        this_.nowIndex = count
        // console.log(this_.nowIndex)
      };
  
      // 4 设置左按钮点击事件
      arrLeft.onclick = function () {
        // 检测当前是否显示第一张
        if (count === 1) {
          ul.style.left = -(ulLis.length - 1) * imgWidth + 'px';
          count = ulLis.length - 1; // 将count更新
        }
  
        // 基本滚动操作
        count--;
        var target = -count * imgWidth;
        move(ul, target);
        // for (var i = 0; i < olLis.length; i++) {
        //   olLis[i].classList.remove('current');
        // }
        // olLis[count].classList.add('current');

        if (this_.playState) {
          let myVideo = this_.$refs['videoPlayer' + this_.nowIndex];
          myVideo[0].pause();
        }

        this_.nowIndex = count
        // console.log(this_.nowIndex)
      };
  
  
      // --- 自动播放功能
      // 1 设置定时器，进行自动播放
      this_.timer = setInterval(function () {
        // 2 调用右按钮的点击事件, 通过click()操作
        arrRight.click();
      }, 3000);
  
      // 3 鼠标移入时，设置自动播放停止
      //   - 需要给box重复设置onmouseover和onmouseout
      box.addEventListener('mouseover', function () {
        clearInterval(this_.timer);
      });
  
      box.addEventListener('mouseout', function () {
        if (this_.playState) {
          // console.log('播放了')
          return
        }
        // 重新开启时，必须设置给timer，而且必须是全局变量
        this_.timer = setInterval(function () {
          arrRight.click();
        }, 3000);
      });
  
      /* move函数用于让某个元素移动到指定位置
        - element 是要运动的元素，DOM对象，别写id名或标签名之类的东西
        - target 是目标位置，数值类型
      */
      function move(element, target) {
        // 为了避免元素出现抖动
        clearInterval(element.timer);
        // 设置新运动的定时器操作:
        element.timer = setInterval(function () {
          // 1 获取元素当前的位置
          var current = element.offsetLeft;
          // 2 计算每次要运动的距离(步长)
          var step = (target - current) / 10;
          // 对step计算的结果进行取整，确保至少移动1px
          //   - 根据step的正负设置对应的向上或向下取整操作
          step = step > 0 ? Math.ceil(step) : Math.floor(step);
          // 3 计算新的运动位置
          current += step;
          // 4 设置给元素的left进行运动
          element.style.left = current + 'px';
          // 5 当元素运动到目标位置后，清除定时器
          if (current === target) {
            clearInterval(element.timer);
          }
        }, 20);
      }
    },

    // 播放
    play() {
      this.playState = true
    },
    // 暂停
    pause() {
      this.playState = false
    },
    // 播放结束
    ended() {
      // this.playState = false
      let videoLength = this.videoList.length
      let currentVideoLength = this.currentVideo.list.length
      if (this.currentVideoIndex === currentVideoLength - 1) {
        if (this.currentIndex === videoLength - 1) {
          this.currentIndex = 0
          this.currentVideo = this.videoList[0]
        } else {
          this.currentIndex++
          this.currentVideo = this.videoList[this.currentIndex]
        }
        this.currentVideoIndex = 0
      } else {
        this.currentVideoIndex++
      }
    },

    toIndustryApplication() {
      this.$router.push("/industral/application/index");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
}
</script>
<style lang="scss">
.aiEditorVideo {
  width: 100%;
  background: #B0B0CD;

  .aiEditorVideo-center {
    width: 1200px;
    height: 700px;
    color: #000;
    position: relative;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin: 0 auto;
    padding-top: 123px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;

    .center-left {
      width: 803px;
      height: 434px;
      background: #000000;
      border: 1px solid #919AE7;
      border-radius: 16px;
      text-align: center;
      position: relative;
      display: flex;
      justify-content: center;
      overflow: hidden;
      .ai-editor-video {
        width: 100%;
        height: 100%;
        transform: scale(1.01, 1.02) translateX(0px);
      }
      .center-left-bottomNav {
        width: 100%;
        height: 58px;
        color: #FFFFFF;
        background: #000000;
        opacity: 0.61;
        // border-radius: 0px 0px 16px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 3;
        .el-icon-arrow-left,
        .el-icon-arrow-right {
          color: #C0C0DF;
          font-size: 26px;
          cursor: pointer;
        }
        .el-icon-arrow-left {
          margin-left: 26px;
        }
        .el-icon-arrow-right {
          margin-right: 26px;
        }
        .bottomNav-tips {
          display: flex;
          flex-direction: column;
          align-items: center;
          p {
            font-size: 18px;
            font-family: Arial Unicode MS;
            font-weight: 400;
          }
          ul {
            display: flex;
            align-items: center;
            margin-top: 10px;
            li {
              width: 5px;
              height: 5px;
              background: #585C7B;
              border-radius: 50%;
              &:nth-child(n+1) {
                margin-left: 5px;
              }
            }
            .current-dot {
              background-color: #fff;
            }
          }
        }
      }
    }

    .center-right {
      width: 371px;
      height: 432px;
      background: #4E4E71;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      &:hover {
        .arrow {
          .arrow-top {
            background: url("../../../public/images/home/icon-white-top.png") no-repeat;
            background-size: 100% 100%;
          }
          .arrow-bottom {
            background: url("../../../public/images/home/icon-white-bottom.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .arrow {
        display: flex;
        .arrow-top,
        .arrow-bottom {
          width: 29px;
          height: 21px;
          cursor: pointer;
        }
        .arrow-top {
          background: url("../../../public/images/home/icon-grey-top.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 15px;
          left: 0;
          right: 0;
          margin: auto;
        }
        .arrow-bottom {
          background: url("../../../public/images/home/icon-grey-bottom.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          bottom: 15px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
      ul {
        display: flex;
        flex-direction: column;
        align-items: center;
        li {
          width: 312px;
          height: 145px;
          margin-top: 47.5px;
          // padding-top: 47.5px;
          position: relative;
          cursor: pointer;
          .mode-title {
            width: 132px;
            height: 32px;
            background: rgba(144, 144, 178, 0.7);
            color: #FFFFFF;
            font-size: 16px;
            border-radius: 16px;
            line-height: 32px;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            overflow: hidden;
          }
          .selector-img {
            background: #8E8EBC;
            border: 2px solid #C6C6F2;
            box-sizing: border-box;
          }
        }
      }
    }

    .special-effects {
      width: 803px;
      position: absolute;
      left: 0;
      bottom: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #233355;
        margin: 0 27px;
      }
      .ul-left {
        height: 31px;
        display: flex;
        flex-direction: row-reverse;
        li {
          width: 12px;
          height: 30px;
          background: url("../../../public/images/home/left-block-decorative01.png") no-repeat;
          background-size: 100% 100%;
          &:nth-child(n+1) {
            margin-left: -5px;
          }
        }
        .li-hover-left {
          background: url("../../../public/images/home/left-block-decorative02.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .ul-right {
        height: 31px;
        display: flex;
        li {
          width: 12px;
          height: 30px;
          background: url("../../../public/images/home/right-block-decorative01.png") no-repeat;
          background-size: 100% 100%;
          &:nth-child(n+1) {
            margin-right: -5px;
          }
        }
        .li-hover-right {
          background: url("../../../public/images/home/right-block-decorative02.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .all {
    width: 800px;
    height: 450px;
    margin: 47px auto 17px;
    position: relative;
    &:hover {
      #arr {
        display: block;
      }
    }
  }

  .screen {
    width: 800px;
    height: 450px;
    /* overflow: hidden; */
    position: relative;
    ul {
      height: 100%;
      position: absolute;
      left: 0;
      top: 0px;
      // width: 3000px;
      /* transition: left 1s; */
      display: flex;
      li {
        width: 800px;
        height: 100%;
        overflow: hidden;
        padding: 0 10px;
        box-sizing: border-box;
        position: relative;
        .video-apply {
          width: 100%;
          height: 100%;
          background-color: #ccc;
          border-radius: 18px;
        }
        .video-title {
          width: 780px;
          color: #fff;
          bottom: 32px;
          margin: auto;
          position: absolute;
          z-index: 9;
          display: flex;
          justify-content: space-between;
          span {
            &:first-child {
              font-size: 23px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #FFFFFF;
              line-height: 28px;
              margin-left: 30px;
            }
            &:last-child {
              width: 91px;
              height: 29px;
              color: #000;
              background-color: #fff;
              border: 1px solid #fff;
              border-radius: 25px;
              font-size: 14px;
              margin-right: 38px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              .icon-video-play {
                width: 12px;
                height: 12px;
                background: url("../../../public/images/home/icon-play.png") no-repeat;
                background-size: contain;
                margin-left: 5px;
              }
            }
          }
        }
        .film {
          width: 780px;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.5);
          border-radius: 18px;
          position: absolute;
          z-index: 9;
        }
      }
    }
  }


  .all ol {
    position: absolute;
    right: 10px;
    bottom: 10px;
    line-height: 20px;
    text-align: center;
  }
  .all ol li {
    float: left;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid #ccc;
    margin-left: 10px;
    cursor: pointer;
  }
  .all ol li.current {
    background: yellow;
  }

  #arr {
    display: none;
  }
  #arr span {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    font-family: '黑体';
    color: #3E3E40;
    background: rgba(195, 184, 184, 0.66);
    border-radius: 50%;
    position: absolute;
    left: -180px;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: pointer;
    z-index: 19;
  }
  #arr #right {
    right: -180px;
    left: auto;
  }

  .seamless-warp{
    width: 100%;
    height: 160px;
    // height: calc(100% - 16px);
    overflow: hidden;
    margin: 20px auto;
    ul {
      width: 100%;
      display: flex;
      li {
        width: 300px;
        height: 160px;
        margin: 0 10px;
        border-radius: 18px;
        overflow: hidden;
        display: flex;
        position: relative;
        cursor: pointer;
        img {
          flex: 1;
        }
        .film-img {
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.5);
          border-radius: 18px;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}

</style>